import { useMemo, useSyncExternalStore } from 'react';
import { subscribe, getJobs, getServerJobs } from '../utils/aiJobs';

const isActive = (j) => j.status === 'queued' || j.status === 'generating';
const doneAt = (j) => j.finishedAt || j.startedAt || 0;

/**
 * Задачи одного инструмента. getSnapshot отдаёт ВЕСЬ массив (кэшированная ссылка), фильтрация —
 * в useMemo: новый массив из getSnapshot = бесконечный цикл рендера.
 */
export const useToolJobs = (toolId) => {
  const all = useSyncExternalStore(subscribe, getJobs, getServerJobs);
  return useMemo(() => {
    const mine = all.filter((j) => j.toolId === toolId);
    return {
      jobs: mine.filter((j) => isActive(j) || j.status === 'error').sort((a, b) => b.startedAt - a.startedAt),
      latestDone: mine.filter((j) => j.status === 'done').sort((a, b) => doneAt(b) - doneAt(a))[0] || null,
      activeCount: mine.filter(isActive).length,
    };
  }, [all, toolId]);
};

const countActive = () => getJobs().filter(isActive).length;
const zero = () => 0;

/** Счётчик для чипа вкладки. Число из getSnapshot безопасно — оно сравнивается по значению. */
export const useActiveJobCount = () => useSyncExternalStore(subscribe, countActive, zero);
